module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagec",
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/title.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fpage"
  }), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("We wouldn’t be where we are without "), _c('em', [_vm._v("you")]), _vm._v(". Thank you for using our patterns and reading our books. We love to see the way you incorporate our designs into the wonderful quilts you make. You keep us going.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many people at C&T Publishing have been very good to us. First, Todd Hensley, CEO, welcomed us with open arms. Amy Marson, publisher, is always there to support us. Lynn Koolish, our editor, is the person we work with the most, and she has helped to make each and every book better. We appreciate the help that all of them have given to us.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It would be nice to be perfect, but we aren’t, so we are very grateful to Alison Schmidt, technical editor, who makes sure we get the details right, and to Jessica Jenkins, the production coordinator, who kept everything in this complicated book on track. Diane Pederson has an eye for photography that we greatly appreciate. April Mostek, this book’s designer, has given "), _c('em', [_vm._v("The Best-Ever Appliqué Sampler")]), _vm._v(" its distinctive appearance. We thank you all for your excellent efforts.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e15b1f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607054726_02_ack.vue
// module id = 60
// module chunks = 0